export default __webpack_public_path__ + "static/media/isso.7c9271b4.png";